import PbAjax from '../../lib/pbajax';
import url from 'c-url';
import publicpb from '../../base/public.pb';
import profileSetpb from './set.pb';
import Cache from 'c-cache';

let cache = new Cache({
    prefix: 'pcuplive'
});
let pbajax = new PbAjax();

class ProfileSet {

    constructor(data = {}){
        this.promise = this.set(data);
    }

    set(data){
        let defer = $.Deferred()
        let businessData = new profileSetpb.Profile.Set.Request(data);
        let requestData = {
                service: 'service',    
                api: '/profile/set',  
                header: {
                    userToken: UP.Global.getUserToken()
                }
            }

        pbajax.do(
            requestData,
            businessData,
            function(res){
                let dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject();
                }
            },
            ()=>{
                defer.reject();
            },
            ()=>{
                defer.reject();
            });
        return defer.promise();
    }
}

export default ProfileSet;



// WEBPACK FOOTER //
// ./js/component/profile/set.js